import { inject, Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { AppState } from '@state';
import { MyWorkPermit, MyWorkPermitDocumentFile } from '../../work-permits/work-permits.interfaces';
import * as myWorkPermitsActions from './my-work-permits.actions';
import * as selectors from './my-work-permits.selectors';

@Injectable()
export class MyWorkPermitsFacade {
  private readonly store = inject<Store<AppState>>(Store);
  private readonly actions = inject(Actions);

  public myWorkPermits$ = this.store.select(selectors.selectMyWorkPermits);
  public myWorkPermit$ = this.store.select(selectors.selectMyWorkPermit);
  public loadingMyWorkPermit$ = this.store.select(selectors.selectLoadingMyWorkPermit);
  public removingFileIds$ = this.store.select(selectors.selectRemovingFileIds);

  public getMyWorkPermitsSuccess$ = this.actions.pipe(ofType(myWorkPermitsActions.getMyWorkPermitsSuccess));
  public getMyWorkPermitsError$ = this.actions.pipe(ofType(myWorkPermitsActions.getMyWorkPermitsError));
  public uploadDocumentFileSuccess$ = this.actions.pipe(
    ofType(myWorkPermitsActions.uploadMyWorkPermitDocumentFileSuccess)
  );
  public uploadDocumentFileError$ = this.actions.pipe(ofType(myWorkPermitsActions.uploadMyWorkPermitDocumentFileError));

  public getMyWorkPermits(): void {
    this.store.dispatch(myWorkPermitsActions.getMyWorkPermits());
  }

  // Loads the list once if it is not in the store yet (e.g. after a page refresh).
  public getMyWorkPermits$(): Observable<MyWorkPermit[]> {
    return this.myWorkPermits$.pipe(
      tap(myWorkPermits => {
        if (!myWorkPermits) {
          this.getMyWorkPermits();
        }
      }),
      filter(myWorkPermits => !!myWorkPermits)
    );
  }

  public getMyWorkPermit(workPermitId: string): void {
    this.store.dispatch(myWorkPermitsActions.getMyWorkPermit({ workPermitId }));
  }

  public uploadDocumentFile(uploadId: string, workPermitId: string, documentId: string, file: File): void {
    this.store.dispatch(
      myWorkPermitsActions.uploadMyWorkPermitDocumentFile({ uploadId, workPermitId, documentId, file })
    );
  }

  public removeDocumentFile(workPermitId: string, documentId: string, file: MyWorkPermitDocumentFile): void {
    this.store.dispatch(myWorkPermitsActions.removeMyWorkPermitDocumentFile({ workPermitId, documentId, file }));
  }
}
